import { useSubscription } from '@apollo/client';
import { Context as AuthorizationContext } from 'authorization/Context';
import { onEncounterUpdatedSubscription } from 'encounter/Schema';
import React, { useContext, useMemo } from 'react';
import { useMatch } from 'react-router-dom';
import { shortTimezoneDateTime } from 'styleguide/form/Datetime/formatters';
import { PrivateLayoutContext } from 'styleguide/layout/Private/Context';
import { getUserStates, isTelemedicineClinician } from 'user';
import { PATH_WAITINGROOM_LIST } from '..';

export type Props = {};

const TelemedicineWaitingRoomNotification: React.FC<Props> = () => {
  const { user } = useContext(AuthorizationContext);
  const { dispatch } = useContext(PrivateLayoutContext);

  const userStates = useMemo(() => getUserStates(user), [user]);

  const isWaitingRoomPath = !!useMatch({
    path: PATH_WAITINGROOM_LIST,
  });

  useSubscription(onEncounterUpdatedSubscription, {
    variables: {
      patientStates: userStates,
      telemedicineStatuses: ['requested'],
    },
    skip: !isTelemedicineClinician(user) || isWaitingRoomPath,
    fetchPolicy: 'no-cache',
    onSubscriptionData: (_) => {
      dispatch({
        type: 'setNotification',
        value: {
          title: 'New waiting room request',
          content: shortTimezoneDateTime(new Date().toISOString()),
        },
      });
    },
  });

  return null;
};

export default React.memo(TelemedicineWaitingRoomNotification);
